import React, { useEffect, useState } from 'react';

const FADE_OUT_TIME = 3000;

/**
 * 쿠폰 토스트 컴포넌트
 * 메타 채널을 접속한 딜인 경우에만 노출
 */
function CouponToast() {
  const [isRender, setIsRender] = useState(true);
  let { priceInfo } = TMON.oApp.htStorage.htStaticData.htDealInfo;
  if (TMON.oApp.htStorage.htStaticData.bOptionDeal) {
    priceInfo = TMON.oApp.htStorage.htStaticData.htDealInfo.option.priceInfo;
  }

  const discountInfos =
    priceInfo.discountInfos[priceInfo.viewPaymentDiscountInfoKey];
  const isCouponPrice = discountInfos.isCoupon || discountInfos.isPartner;

  useEffect(() => {
    const id = setTimeout(() => {
      setIsRender(false);
      clearInterval(id);
    }, FADE_OUT_TIME);
  }, []);

  return (
    isRender &&
    isCouponPrice && (
      <div className="coupon_toast">
        <p className="text">최대 할인쿠폰 받으세요!</p>
      </div>
    )
  );
}

export default CouponToast;
